/* eslint-disable camelcase */
import React from 'react'
import type { Content } from '@prismicio/client'
import type { SliceComponentProps } from '@prismicio/react'
import type { CollectionProducts } from '@lib/types'
import type { ProductCard } from '@lib/types/product'
import DefaultSubsDetailProductsList from './DefaultSubsDetailProductsList'
import FeaturedProductSubsDetailProductsList from './FeaturedProductSubsDetailProductsList'
/**
 * Props for `SubsDetailProductsList`.
 */
export type SubsDetailProductsListProps =
	SliceComponentProps<Content.SubsDetailProductsListSlice> & {
		collectionProducts?: CollectionProducts
		featuredProduct?: ProductCard | null
	}

export default function SubsDetailProductsList(props: SubsDetailProductsListProps) {
	const { slice } = props
	if (slice.variation === 'featuredProduct') {
		return <FeaturedProductSubsDetailProductsList {...props} />
	}
	return <DefaultSubsDetailProductsList {...props} />
}
